<template>
  <div v-if="contato" class="whatsapp-btn" @click="openWhatsApp">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp">
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue';

  interface Contato {
    whatsappNumber: string;
    whatsappMessage: string;
  }

  const contato = ref<Contato | null>(null);

  const fetchContato = async () => {
  const HYGRAPH_ENDPOINT = process.env.VUE_APP_HYGRAPH_URL;

    const query = `
      query GetContato {
        contacts(first: 1) {
          whatsappNumber
          whatsappMessage
        }
      }
    `;

    try {
      const response = await fetch(HYGRAPH_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
      });
      const { data } = await response.json();

      if (data.contacts.length > 0) {
        contato.value = data.contacts[0];
      }
    } catch (error) {
      console.error("Erro ao carregar dados de contato:", error);
    }
  };

  const formatMessageForWhatsapp = (message: string) => {
    message = message
      .replace(/<strong>(.*?)<\/strong>/g, '*$1*')
      .replace(/<em>(.*?)<\/em>/g, '_$1_')
      .replace(/<s>(.*?)<\/s>/g, '~$1~')
      .replace(/<p>/g, '').replace(/<\/p>/g, '\n');

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = message;
    const finalMessage = tempDiv.textContent || tempDiv.innerText || "";

    return encodeURIComponent(finalMessage.trim());
  };


  const openWhatsApp = () => {
    if (contato.value) {
      const phone = contato.value.whatsappNumber.replace(/\D/g, '').replace(' ','');

      var message = formatMessageForWhatsapp(contato.value.whatsappMessage);

      const url = `https://wa.me/${phone}?text=${(message)}`;
      window.open(url);
    }
  };

  onMounted(fetchContato);
</script>

<style scoped>
  .whatsapp-btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: #25d366;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
    cursor: pointer;
    z-index: 9999;
    transition: transform 0.3s;
  }

  .whatsapp-btn:hover {
    transform: scale(1.1);
  }

  .whatsapp-btn img {
    width: 35px;
    height: 35px;
  }
</style>